// extracted by mini-css-extract-plugin
export default {"checkbox_container":"ConfirmAllSelections_checkbox_container__akSg0","label":"ConfirmAllSelections_label__U4WvZ"};